import { selector, selectorFamily } from 'recoil';
import { PartySubTypeEnum, } from '@zurich/api/party';
import { allValid, alwaysValid, alwaysValidValidationSelector, fileUploadValidationSelector, validateSchema, } from '@zurich/common/recoil';
import { eCommunicationSchema, numberSchema, partyAcademicAffixSchema, partyAreaCodeSchema, partyBusinessNameSchema, partyBusinessSectorsSchema, partyCheckBirthday, partyCitizenshipsNonRequiredSchema, partyCitizenshipsSchema, partyCityNonRequiredSchema, partyCitySchema, partyCivilStatusSchema, partyClubObjectiveSchema, partyCommercialRegisterNumberSchema, partyCountryAustriaSchema, partyCountryCallingCodeSchema, partyCountryNonRequiredSchema, partyCountryOfBirthSchema, partyCountrySchema, partyCustomerRequestMessageSchema, partyDateOfBirthSchema, partyDateOfBirthSchemaNonRequired, partyDateOfBirthUnderAgeSchema, partyDateOfDeathSchema, partyDDocNumberSchema, partyDDocSinceSchema, partyDDocUntilSchema, partyDiplomaticStatusSchema, partyDoorNumberSchema, partyEducationSchema, partyEmailSchema, partyEmailSchemaNotRequired, partyEmploymentSchema, partyFixedPartySchema, partyForeignPostalCodeNonRequiredSchema, partyForeignPostalCodeSchema, partyFoundingYearSchema, partyHouseNumberFromNonRequiredSchema, partyHouseNumberFromSchema, partyHouseNumberToSchema, partyInsolvencyEndSchema, partyInsolvencyStartSchema, partyLegalFormNotRequiredSchema, partyLegalFormSchema, partyLiquidationDateSchema, partyLocalHouseHoldMergeSelectionSchema, partyLocalHouseHoldMoveTypeSchema, partyLocalPhoneNumberSchema, partyMajorCustomerSchema, partyMarriageOnSchema, partyNameAffixSchema, partyNameSchema, partyOccupationSchema, partyOrganizationNameSchema, partyOrganizationTypeSchema, partyOwnershipCheckSchema, partyPlaceOfBirthSchema, partyPubliclyTradedSchema, partySalutationSchema, partyStreetNonRequiredSchema, partyStreetSchema, partySubTypeSchema, partyUidSchema, partyVvoNumberSchema, partyZvrNumberSchema, } from '../../forms';
import { localPartyCustomerRequestAtom, localPartyHouseholdMergeSelectionAtom, localPartyHouseholdMoveTypeAtom, } from '../atoms';
import { localPartyAcademicDegreePostfixSelector, localPartyAcademicDegreePrefixSelector, localPartyAreaCodeSelector, localPartyBusinessNameSelector, localPartyBusinessSectorsSelector, localPartyChildrenSelector, localPartyCitizenshipsSelector, localPartyCitySelectorFamily, localPartyCivilStatusSelector, localPartyClubObjectiveSelector, localPartyCommercialRegisterNumberSelector, localPartyCountryCallingCodeSelector, localPartyCountryOfBirthSelector, localPartyCountrySelectorFamily, localPartyDateOfBirthSelector, localPartyDateOfDeathSelector, localPartyDDocNumberSelector, localPartyDDocSinceSelector, localPartyDDocUntilSelector, localPartyDiplomaticStatusSelector, localPartyDoorNumberSelectorFamily, localPartyDunsNumberSelector, localPartyECommunicationSelector, localPartyEducationSelector, localPartyEmailSelector, localPartyEmploymentSelector, localPartyFirstNameSelector, localPartyFixedPartySelector, localPartyFoundingYearSelector, localPartyGisaNumberSelector, localPartyHouseNumberFromSelectorFamily, localPartyHouseNumberToSelectorFamily, localPartyInsolvencyEndSelector, localPartyInsolvencyStartSelector, localPartyLastNameSelector, localPartyLegalFormSelector, localPartyLiquidationDateSelector, localPartyLocalPhoneNumberSelector, localPartyMajorCustomerSelector, localPartyMarriageOnSelector, localPartyNameAffixSelector, localPartyNumberOfClubMembersSelector, localPartyNumberOfEmployeesSelector, localPartyOccupationSelector, localPartyOrganizationNameSelector, localPartyOrganizationTypeSelector, localPartyOwnershipCheckSelector, localPartyPersonDataFileUploadSelector, localPartyPlaceOfBirthSelector, localPartyPostalCodeSelectorFamily, localPartyPubliclyTradedSelector, localPartySalutationSelector, localPartyStreetSelectorFamily, localPartySubTypeSelector, localPartyUidSelector, localPartyVvoNumberSelector, localPartyZvrNumberSelector, } from '../selectors';
const validateAffixSchemasCombined = (get) => {
    const partyAcademicDegreePrefix = get(localPartyAcademicDegreePrefixSelector);
    const partyAcademicDegreePostfix = get(localPartyAcademicDegreePostfixSelector);
    return validateSchema(partyAcademicAffixSchema, {
        partyAcademicDegreePrefix,
        partyAcademicDegreePostfix,
    });
};
export const localPartySubTypeValidationSelector = selector({
    key: 'validation/local/partySubType',
    get: ({ get }) => validateSchema(partySubTypeSchema, get(localPartySubTypeSelector)),
});
export const localPartySalutationValidationSelector = selector({
    key: 'validation/local/partySalutation',
    get: ({ get }) => validateSchema(partySalutationSchema, get(localPartySalutationSelector)),
});
export const localPartyAcademicDegreePrefixPostfixCombinedValidationSelector = selector({
    key: 'validation/local/partyAcademicDegreeAffix',
    get: ({ get }) => validateAffixSchemasCombined(get),
});
/*export const localPartyDegreeAwardedValidationSelector = selector({
  key: 'validation/local/partyDegreeAwarded',
  get: ({ get }) =>
    validateSchema(
      partyDegreeAwardedSchema,
      get(localPartyDegreeAwardedSelector)
    ),
});*/
export const localPartyFirstNameValidationSelector = selector({
    key: 'validation/local/partyFirstName',
    get: ({ get }) => {
        const firstName = get(localPartyFirstNameSelector);
        return validateSchema(partyNameSchema, firstName);
    },
});
export const localPartyCustomerRequestValidationSelector = selector({
    key: 'validation/local/partyCustomerRequest',
    get: ({ get }) => {
        const message = get(localPartyCustomerRequestAtom);
        return validateSchema(partyCustomerRequestMessageSchema, message);
    },
});
export const localPartyLastNameValidationSelector = selector({
    key: 'validation/local/partyLastName',
    get: ({ get }) => {
        const lastName = get(localPartyLastNameSelector);
        return validateSchema(partyNameSchema, lastName);
    },
});
export const localPartyNameAffixValidationSelector = selector({
    key: 'validation/local/partyNameAffix',
    get: ({ get }) => validateSchema(partyNameAffixSchema, get(localPartyNameAffixSelector)),
});
export const localPartyDateOfBirthValidationSelector = selector({
    key: 'validation/local/partyDateOfBirth',
    get: ({ get }) => validateSchema(partyDateOfBirthSchema, get(localPartyDateOfBirthSelector)),
});
export const localPartyDateOfBirthUnderAgeValidationSelector = selector({
    key: 'validation/local/partyDateOfBirthUnderAge',
    get: ({ get }) => validateSchema(partyDateOfBirthUnderAgeSchema, get(localPartyDateOfBirthSelector)),
});
export const localPartyDateOfBirthNonRequiredValidationSelector = selector({
    key: 'validation/local/partyDateOfBirthNonRequired',
    get: ({ get }) => validateSchema(partyDateOfBirthSchemaNonRequired, get(localPartyDateOfBirthSelector)),
});
export const localPartyDateOfDeathValidationSelector = selector({
    key: 'validation/local/partyDateOfDeath',
    get: ({ get }) => {
        const dateOfDeath = get(localPartyDateOfDeathSelector);
        const dateOfBirth = get(localPartyDateOfBirthSelector);
        return validateSchema(partyDateOfDeathSchema, {
            dateOfDeath,
            dateOfBirth,
        });
    },
});
export const localPartyOrganizationNameValidationSelector = selector({
    key: 'validation/local/partyOrganiztationName',
    get: ({ get }) => validateSchema(partyOrganizationNameSchema, get(localPartyOrganizationNameSelector)),
});
export const localPartyBusinessNameValidationSelector = selector({
    key: 'validation/local/partyBusinessName',
    get: ({ get }) => validateSchema(partyBusinessNameSchema, get(localPartyBusinessNameSelector)),
});
export const localPartyCitizenshipsValidationSelector = selector({
    key: 'validation/local/partyCitizenships',
    get: ({ get }) => validateSchema(partyCitizenshipsSchema, get(localPartyCitizenshipsSelector)),
});
export const localPartyCitizenshipsNonRequiredValidationSelector = selector({
    key: 'validation/local/partyCitizenships/nonRequired',
    get: ({ get }) => validateSchema(partyCitizenshipsNonRequiredSchema, get(localPartyCitizenshipsSelector)),
});
export const localPartyMarriageOnValidationSelector = selector({
    key: 'validation/local/partyMarriageOn',
    get: ({ get }) => {
        const dateOfMarriage = get(localPartyMarriageOnSelector);
        const dateOfDeath = get(localPartyDateOfDeathSelector);
        return validateSchema(partyMarriageOnSchema, {
            dateOfMarriage,
            dateOfDeath,
        });
    },
});
export const localPartyChildrenValidationSelector = selector({
    key: 'validation/local/partyChildren',
    get: ({ get }) => {
        const children = get(localPartyChildrenSelector);
        return validateSchema(numberSchema, children);
    },
});
export const localPartyPlaceOfBirthValidationSelector = selector({
    key: 'validation/local/partyPlaceOfBirth',
    get: ({ get }) => validateSchema(partyPlaceOfBirthSchema, get(localPartyPlaceOfBirthSelector)),
});
export const updatePersonDataCustomerRequestFormValidationSelector = selector({
    key: 'validation/updatePersonDataCustomerRequestForm',
    get: ({ get }) => {
        const isDocumentUploadRequired = get(localPartyPersonDataFileUploadSelector);
        const necessaryValidations = {
            partySalutation: get(localPartySalutationValidationSelector),
            partyAcademicDegreePostfix: get(localPartyAcademicDegreePrefixPostfixCombinedValidationSelector),
            partyAcademicDegreePrefix: get(localPartyAcademicDegreePrefixPostfixCombinedValidationSelector),
            partyFirstName: get(localPartyFirstNameValidationSelector),
            partyLastName: get(localPartyLastNameValidationSelector),
            partyDateOfBirth: get(localPartyDateOfBirthNonRequiredValidationSelector),
        };
        const optionalValidations = {
            fileUpload: get(fileUploadValidationSelector('profile-party-data-customer-request')),
        };
        return allValid(isDocumentUploadRequired
            ? { ...necessaryValidations, ...optionalValidations }
            : necessaryValidations);
    },
});
export const localPartyCountryOfBirthValidationSelector = selector({
    key: 'validation/local/partyCountryOfBirth',
    get: ({ get }) => validateSchema(partyCountryOfBirthSchema, get(localPartyCountryOfBirthSelector)),
});
export const localPartyOccupationValidationSelector = selector({
    key: 'validation/local/partyOccupation',
    get: ({ get }) => validateSchema(partyOccupationSchema, get(localPartyOccupationSelector)),
});
export const localPartyCivilStatusValidationSelector = selector({
    key: 'validation/local/civilStatus',
    get: ({ get }) => {
        const civilStatus = get(localPartyCivilStatusSelector);
        const dateOfMarriage = get(localPartyMarriageOnSelector);
        return validateSchema(partyCivilStatusSchema, {
            civilStatus,
            dateOfMarriage,
        });
    },
});
export const localPartyLegalFormValidationSelector = selector({
    key: 'validation/local/partyLegalForm',
    get: ({ get }) => {
        const legalForm = get(localPartyLegalFormSelector);
        return validateSchema(partyLegalFormSchema, legalForm);
    },
});
export const localPartyLegalFormNotRequiredValidationSelector = selector({
    key: 'validation/local/partyLegalFormNotRequired',
    get: ({ get }) => {
        const legalForm = get(localPartyLegalFormSelector);
        return validateSchema(partyLegalFormNotRequiredSchema, legalForm);
    },
});
export const localPartyBusinessSectorValidationSelector = selector({
    key: 'validation/local/partyBusinessSector',
    get: ({ get }) => validateSchema(partyBusinessSectorsSchema, get(localPartyBusinessSectorsSelector)),
});
export const localPartyInsolvencyStartValidationSelector = selector({
    key: 'validation/local/partyInsolvencyStart',
    get: ({ get }) => validateSchema(partyInsolvencyStartSchema, get(localPartyInsolvencyStartSelector)),
});
export const localPartyInsolvencyEndValidationSelector = selector({
    key: 'validation/local/partyInsolvencyEnd',
    get: ({ get }) => {
        const start = get(localPartyInsolvencyStartSelector);
        const end = get(localPartyInsolvencyEndSelector);
        return validateSchema(partyInsolvencyEndSchema, { start, end });
    },
});
// export const localPartyInsolvencyModificationReasonValidationSelector = selector({
//   key: 'validation/local/partyInsolvency',
//   get: ({ get }) =>
//     validateSchema(partyInsolvencyModificationReasonSchema, get(localPartyInsolvencyModificationReasonSelector)),
// });
export const updateInsolvencyFormValidationSelector = selector({
    key: 'validation/local/partyInsolvencyForm',
    get: ({ get }) => allValid({
        insolvencyStart: get(localPartyInsolvencyStartValidationSelector),
        insolvencyEnd: get(localPartyInsolvencyEndValidationSelector),
    }),
});
export const localPartyDiplomaticStatusValidationSelector = selector({
    key: 'validation/local/diplomaticStatus',
    get: ({ get }) => validateSchema(partyDiplomaticStatusSchema, get(localPartyDiplomaticStatusSelector)),
});
export const localPartyDDocNumberValidationSelector = selector({
    key: 'validation/local/dDocNumber',
    get: ({ get }) => {
        const dDocNumber = get(localPartyDDocNumberSelector);
        const diplomaticStatus = get(localPartyDiplomaticStatusSelector);
        const dDocSince = get(localPartyDDocSinceSelector);
        return validateSchema(partyDDocNumberSchema, {
            dDocNumber,
            diplomaticStatus,
            dDocSince,
        });
    },
});
export const localPartyDDocSinceValidationSelector = selector({
    key: 'validation/local/dDocSince',
    get: ({ get }) => validateSchema(partyDDocSinceSchema, get(localPartyDDocSinceSelector)),
});
export const localPartyDDocUntilValidationSelector = selector({
    key: 'validation/local/dDocUntil',
    get: ({ get }) => validateSchema(partyDDocUntilSchema, get(localPartyDDocUntilSelector)),
});
export const createPartyGeneralFormValidationSelectorFamily = selectorFamily({
    key: 'validation/local/partyGeneralForm',
    get: ({ optionalFields }) => ({ get }) => {
        const partySubType = get(localPartySubTypeSelector);
        return partySubType === PartySubTypeEnum.UNTERNEHMEN ||
            partySubType === PartySubTypeEnum.VEREIN
            ? allValid({
                partySubType: get(localPartySubTypeValidationSelector),
                partyLegalForm: get(localPartyLegalFormNotRequiredValidationSelector),
                partyOrganizationName: get(localPartyOrganizationNameValidationSelector),
            })
            : allValid({
                partySubType: get(localPartySubTypeValidationSelector),
                partySalutation: get(localPartySalutationValidationSelector),
                //partyDegreeAwarded: get(localPartyDegreeAwardedValidationSelector),
                partyAcademicDegreePostfix: get(localPartyAcademicDegreePrefixPostfixCombinedValidationSelector),
                partyAcademicDegreePrefix: get(localPartyAcademicDegreePrefixPostfixCombinedValidationSelector),
                partyFirstName: get(localPartyFirstNameValidationSelector),
                partyLastName: get(localPartyLastNameValidationSelector),
                partyDateOfBirth: get(optionalFields?.dateOfBirth
                    ? localPartyDateOfBirthNonRequiredValidationSelector
                    : localPartyDateOfBirthValidationSelector),
                partyCitizenships: get(optionalFields?.citizenship
                    ? localPartyCitizenshipsNonRequiredValidationSelector
                    : localPartyCitizenshipsValidationSelector),
                partyOccupation: get(localPartyOccupationValidationSelector),
                partyLegalForm: partySubType === PartySubTypeEnum.PRIVATPERSON
                    ? get(alwaysValidValidationSelector)
                    : get(localPartyLegalFormNotRequiredValidationSelector),
                partyBusinessName: partySubType === PartySubTypeEnum.EINZELUNTERNEHMER
                    ? get(localPartyBusinessNameValidationSelector)
                    : get(alwaysValidValidationSelector),
                partyOrganizationType: partySubType === PartySubTypeEnum.EINZELUNTERNEHMER
                    ? get(localPartyOrganizationTypeValidationSelector)
                    : get(alwaysValidValidationSelector),
            });
    },
});
export const localPartyOwnershipCheckValidationSelector = selector({
    key: 'validation/local/partyOwnershipCheck',
    get: ({ get }) => {
        const ownershipCheck = get(localPartyOwnershipCheckSelector);
        return validateSchema(partyOwnershipCheckSchema, ownershipCheck);
    },
});
export const localPartyPubliclyTradedValidationSelector = selector({
    key: 'validation/local/partyPubliclyTraded',
    get: ({ get }) => {
        const publiclyTraded = get(localPartyPubliclyTradedSelector);
        return validateSchema(partyPubliclyTradedSchema, publiclyTraded);
    },
});
export const localPartyMajorCustomerValidationSelector = selector({
    key: 'validation/local/partyMajorCustomer',
    get: ({ get }) => {
        const majorCustomer = get(localPartyMajorCustomerSelector);
        return validateSchema(partyMajorCustomerSchema, majorCustomer);
    },
});
export const localPartyClubObjectiveValidationSelector = selector({
    key: 'validation/local/partyClubObjective',
    get: ({ get }) => {
        const clubObjective = get(localPartyClubObjectiveSelector);
        return validateSchema(partyClubObjectiveSchema, clubObjective);
    },
});
export const localPartyOrganizationTypeValidationSelector = selector({
    key: 'validation/local/partyOrganizationType',
    get: ({ get }) => {
        const organizationType = get(localPartyOrganizationTypeSelector);
        return validateSchema(partyOrganizationTypeSchema, organizationType);
    },
});
export const localPartyFoundingYearValidationSelector = selector({
    key: 'validation/local/partyFoundingYear',
    get: ({ get }) => {
        const foundingYear = get(localPartyFoundingYearSelector);
        return validateSchema(partyFoundingYearSchema, foundingYear);
    },
});
export const localPartyLiquidationDateValidationSelector = selector({
    key: 'validation/local/partyLiquidationDate',
    get: ({ get }) => {
        const foundingYear = get(localPartyFoundingYearSelector);
        const liquidationDate = get(localPartyLiquidationDateSelector);
        return validateSchema(partyLiquidationDateSchema, {
            foundingYear,
            liquidationDate,
        });
    },
});
export const localPartyNumberOfEmployeesValidationSelector = selector({
    key: 'validation/local/partyNumberOfEmployees',
    get: ({ get }) => {
        const numberOfEmployees = get(localPartyNumberOfEmployeesSelector);
        return validateSchema(numberSchema, numberOfEmployees);
    },
});
export const localPartyNumberOfClubMembersValidationSelector = selector({
    key: 'validation/local/partyNumberOfClubMembers',
    get: ({ get }) => {
        const numberOfClubMembers = get(localPartyNumberOfClubMembersSelector);
        return validateSchema(numberSchema, numberOfClubMembers);
    },
});
export const localPartyCommercialRegisterNumberValidationSelector = selector({
    key: 'validation/local/partyCommercialRegisterNumber',
    get: ({ get }) => {
        const commercialRegisterNumber = get(localPartyCommercialRegisterNumberSelector);
        return validateSchema(partyCommercialRegisterNumberSchema, commercialRegisterNumber);
    },
});
export const localPartyGisaNumberValidationSelector = selector({
    key: 'validation/local/partyGisaNumber',
    get: ({ get }) => {
        const gisaNumber = get(localPartyGisaNumberSelector);
        return validateSchema(numberSchema, gisaNumber);
    },
});
export const localPartyUidValidationSelector = selector({
    key: 'validation/local/partyUid',
    get: ({ get }) => {
        const uid = get(localPartyUidSelector);
        return validateSchema(partyUidSchema, uid);
    },
});
export const localPartyDunsNumberValidationSelector = selector({
    key: 'validation/local/partyDunsNumber',
    get: ({ get }) => {
        const dunsNumber = get(localPartyDunsNumberSelector);
        return validateSchema(numberSchema, dunsNumber);
    },
});
export const localPartyZvrNumberValidationSelector = selector({
    key: 'validation/local/partyZvrNumber',
    get: ({ get }) => {
        const zvrNumber = get(localPartyZvrNumberSelector);
        return validateSchema(partyZvrNumberSchema, zvrNumber);
    },
});
export const localPartyFixedPartyValidationSelector = selector({
    key: 'validation/local/partyFixedParty',
    get: ({ get }) => {
        const fixedParty = get(localPartyFixedPartySelector);
        return validateSchema(partyFixedPartySchema, fixedParty);
    },
});
export const localPartyVvoNumberValidationSelector = selector({
    key: 'validation/local/partyVvoNumber',
    get: ({ get }) => {
        const vvoNumber = get(localPartyVvoNumberSelector);
        return validateSchema(partyVvoNumberSchema, vvoNumber);
    },
});
export const updateCompanyDataFormValidationSelector = selector({
    key: 'validation/local/partyCompanyDataForm',
    get: ({ get }) => {
        const partySubType = get(localPartySubTypeSelector);
        const sharedFields = {
            partyLegalForm: get(localPartyLegalFormValidationSelector),
            partyFoundingYear: get(localPartyFoundingYearValidationSelector),
            partyLiquidationDate: get(localPartyLiquidationDateValidationSelector),
            partyNumberOfEmployees: get(localPartyNumberOfEmployeesValidationSelector),
            partyGisaNumber: get(localPartyGisaNumberValidationSelector),
            partyUid: get(localPartyUidValidationSelector),
            partyDunsNumber: get(localPartyDunsNumberValidationSelector),
            partyCommercialRegisterNumber: get(localPartyCommercialRegisterNumberValidationSelector),
        };
        switch (partySubType) {
            case PartySubTypeEnum.EINZELUNTERNEHMER:
                return allValid({
                    ...sharedFields,
                    partyBusinessName: get(localPartyBusinessNameValidationSelector),
                });
            case PartySubTypeEnum.UNTERNEHMEN:
                return allValid({
                    ...sharedFields,
                    partySubType: get(localPartySubTypeValidationSelector),
                    partyOrganizationName: get(localPartyOrganizationNameValidationSelector),
                    partyOwnershipCheck: get(localPartyOwnershipCheckValidationSelector),
                    partyPubliclyTraded: get(localPartyPubliclyTradedValidationSelector),
                    partyMajorCustomer: get(localPartyMajorCustomerValidationSelector),
                    partyOrganizationType: get(localPartyOrganizationTypeValidationSelector),
                    // partyFixedParty: get(localPartyFixedPartyValidationSelector),
                    // partyVvoNumber: get(localPartyVvoNumberValidationSelector),
                });
            case PartySubTypeEnum.VEREIN:
            default:
                return allValid({
                    ...sharedFields,
                    partySubType: get(localPartySubTypeValidationSelector),
                    partyOrganizationName: get(localPartyOrganizationNameValidationSelector),
                    partyClubObjective: get(localPartyClubObjectiveValidationSelector),
                    partyZvrNumber: get(localPartyZvrNumberValidationSelector),
                    //partyFixedParty: get(localPartyFixedPartyValidationSelector),
                    partyNumberOfClubMembers: get(localPartyNumberOfClubMembersValidationSelector),
                });
        }
    },
});
export const updateDiplomaticDataFormValidationSelector = selector({
    key: 'validation/local/partyDiplomaticDataForm',
    get: ({ get }) => {
        const partySubType = get(localPartySubTypeSelector);
        const sharedFields = {
            partyDiplomaticStatus: get(localPartyDiplomaticStatusValidationSelector),
        };
        if (partySubType === PartySubTypeEnum.PRIVATPERSON ||
            partySubType === PartySubTypeEnum.EINZELUNTERNEHMER) {
            return allValid({
                ...sharedFields,
                partyLegitimationCardNo: get(localPartyDDocNumberValidationSelector),
                legitimationCardValidFrom: get(localPartyDDocSinceValidationSelector),
                legitimationCardValidTil: get(localPartyDDocUntilValidationSelector),
            });
        }
        return allValid(sharedFields);
    },
});
export const localPartyEducationValidationSelector = selector({
    key: 'validation/local/partyEducation',
    get: ({ get }) => {
        const education = get(localPartyEducationSelector);
        return validateSchema(partyEducationSchema, education);
    },
});
export const localPartyEmploymentValidationSelector = selector({
    key: 'validation/local/partyEmployment',
    get: ({ get }) => {
        const employment = get(localPartyEmploymentSelector);
        return validateSchema(partyEmploymentSchema, employment);
    },
});
export const updateProfessionFormValidationSelector = selector({
    key: 'validation/local/partyProfessionForm',
    get: ({ get }) => allValid({
        partyEducation: get(localPartyEducationValidationSelector),
        partyEmployment: get(localPartyEmploymentValidationSelector),
        partyOccupation: get(localPartyOccupationValidationSelector),
    }),
});
export const updatePersonDataFormValidationSelector = selector({
    key: 'validation/updatePartnerTypeStep',
    get: ({ get }) => allValid({
        partySubType: get(localPartySubTypeValidationSelector),
        partySalutation: get(localPartySalutationValidationSelector),
        //partyDegreeAwarded: get(localPartyDegreeAwardedValidationSelector),
        partyAcademicDegreePostfix: get(localPartyAcademicDegreePrefixPostfixCombinedValidationSelector),
        partyAcademicDegreePrefix: get(localPartyAcademicDegreePrefixPostfixCombinedValidationSelector),
        partyFirstName: get(localPartyFirstNameValidationSelector),
        partyLastName: get(localPartyLastNameValidationSelector),
        partyNameAffix: get(localPartyNameAffixValidationSelector),
        partyDateOfBirth: get(localPartyDateOfBirthNonRequiredValidationSelector),
        partyDateOfDeath: get(localPartyDateOfDeathValidationSelector),
        partyMarriageOn: get(localPartyMarriageOnValidationSelector),
        partyChildren: get(localPartyChildrenValidationSelector),
        partyCivilStatus: get(localPartyCivilStatusValidationSelector),
        partyCitizenships: get(localPartyCitizenshipsValidationSelector),
        partyPlaceOfBirth: get(localPartyPlaceOfBirthValidationSelector),
        partyCountryOfBirth: get(localPartyCountryOfBirthValidationSelector),
        partyOccupation: get(localPartyOccupationValidationSelector),
    }),
});
export const localPartyCountryValidationSelectorFamily = selectorFamily({
    key: 'validation/local/partyCountry',
    get: (communicationRole) => ({ get }) => validateSchema(partyCountrySchema, get(localPartyCountrySelectorFamily(communicationRole))),
});
export const localPartyCountryOnlyAustriaValidationSelectorFamily = selectorFamily({
    key: 'validation/local/partyCountryAustria',
    get: (communicationRole) => ({ get }) => validateSchema(partyCountryAustriaSchema, get(localPartyCountrySelectorFamily(communicationRole))),
});
export const localPartyCountryNonRequiredValidationSelectorFamily = selectorFamily({
    key: 'validation/local/partyCountry/nonRequired',
    get: (communicationRole) => ({ get }) => validateSchema(partyCountryNonRequiredSchema, get(localPartyCountrySelectorFamily(communicationRole))),
});
export const localPartyPostalCodeValidationSelectorFamily = selectorFamily({
    key: 'validation/local/partyPostalCode',
    get: (communicationRole) => ({ get }) => {
        const countrySelector = localPartyCountrySelectorFamily(communicationRole);
        const postalCodeSelector = localPartyPostalCodeSelectorFamily(communicationRole);
        const country = get(countrySelector);
        const postalCode = get(postalCodeSelector);
        if (country !== null) {
            return validateSchema(partyForeignPostalCodeSchema, {
                country,
                postalCode,
            });
        }
        return alwaysValid(null);
    },
});
export const localPartyPostalCodeNonRequiredValidationSelectorFamily = selectorFamily({
    key: 'validation/local/partyPostalCode/nonRequired',
    get: (communicationRole) => ({ get }) => {
        const country = get(localPartyCountrySelectorFamily(communicationRole));
        const postalCode = get(localPartyPostalCodeSelectorFamily(communicationRole));
        return validateSchema(partyForeignPostalCodeNonRequiredSchema, {
            country,
            postalCode,
        });
    },
});
export const localPartyCityValidationSelectorFamily = selectorFamily({
    key: 'validation/local/partyCity',
    get: (communicationRole) => ({ get }) => {
        const city = get(localPartyCitySelectorFamily(communicationRole));
        const postalCode = get(localPartyPostalCodeSelectorFamily(communicationRole));
        if (postalCode !== null) {
            return validateSchema(partyCitySchema, city);
        }
        return alwaysValid(null);
    },
});
export const localPartyCityNonRequiredValidationSelectorFamily = selectorFamily({
    key: 'validation/local/partyCity/nonRequired',
    get: (communicationRole) => ({ get }) => validateSchema(partyCityNonRequiredSchema, get(localPartyCitySelectorFamily(communicationRole))),
});
export const localPartyStreetValidationSelectorFamily = selectorFamily({
    key: 'validation/local/partyStreet',
    get: (communicationRole) => ({ get }) => validateSchema(partyStreetSchema, get(localPartyStreetSelectorFamily(communicationRole))),
});
export const localPartyStreetNonRequiredValidationSelectorFamily = selectorFamily({
    key: 'validation/local/partyStreet/nonRequired',
    get: (communicationRole) => ({ get }) => validateSchema(partyStreetNonRequiredSchema, get(localPartyStreetSelectorFamily(communicationRole))),
});
export const localPartyHouseNumberFromValidationSelectorFamily = selectorFamily({
    key: 'validation/local/partyHouseNumberFrom',
    get: (communicationRole) => ({ get }) => {
        const houseNumberFrom = get(localPartyHouseNumberFromSelectorFamily(communicationRole));
        return validateSchema(partyHouseNumberFromSchema, houseNumberFrom);
    },
});
export const localPartyHouseNumberFromNonRequiredValidationSelectorFamily = selectorFamily({
    key: 'validation/local/partyHouseNumberFrom/nonRequired',
    get: (communicationRole) => ({ get }) => validateSchema(partyHouseNumberFromNonRequiredSchema, get(localPartyHouseNumberFromSelectorFamily(communicationRole))),
});
export const localPartyHouseNumberToValidationSelectorFamily = selectorFamily({
    key: 'validation/local/partyHouseNumberTo',
    get: (communicationRole) => ({ get }) => {
        const houseNumberTo = get(localPartyHouseNumberToSelectorFamily(communicationRole));
        return validateSchema(partyHouseNumberToSchema, houseNumberTo);
    },
});
export const localPartyDoorNumberValidationSelectorFamily = selectorFamily({
    key: 'validation/local/partyDoorNumber',
    get: (communicationRole) => ({ get }) => {
        const doorNumber = get(localPartyDoorNumberSelectorFamily(communicationRole));
        return validateSchema(partyDoorNumberSchema, doorNumber);
    },
});
export const localPartyEmailValidationSelector = selector({
    key: 'validation/local/partyEmail',
    get: ({ get }) => {
        const emailAddress = get(localPartyEmailSelector);
        const dateOfBirthValue = get(localPartyDateOfBirthSelector);
        if (partyCheckBirthday(dateOfBirthValue)) {
            return validateSchema(partyEmailSchemaNotRequired, emailAddress);
        }
        return validateSchema(partyEmailSchema, emailAddress);
    },
});
export const localPartyEmailNonRequiredValidationSelector = selector({
    key: 'validation/local/partyEmail/nonRequired',
    get: ({ get }) => validateSchema(partyEmailSchemaNotRequired, get(localPartyEmailSelector)),
});
export const localECommunicationValidationSelector = selector({
    key: 'validation/local/eCommunication',
    get: ({ get }) => {
        const eCommunication = get(localPartyECommunicationSelector);
        return validateSchema(eCommunicationSchema, eCommunication);
    },
});
export const localPartyCountryCallingCodeValidationSelector = selector({
    key: 'validation/local/partyCountryCallingCode',
    get: ({ get }) => {
        const countryCode = get(localPartyCountryCallingCodeSelector);
        const areaCode = get(localPartyAreaCodeSelector);
        const phoneNo = get(localPartyLocalPhoneNumberSelector);
        return areaCode || countryCode || phoneNo
            ? validateSchema(partyCountryCallingCodeSchema, get(localPartyCountryCallingCodeSelector))
            : alwaysValid(null);
    },
});
export const localPartyAreaCodeValidationSelector = selector({
    key: 'validation/local/partyAreaCode',
    get: ({ get }) => {
        const areaCode = get(localPartyAreaCodeSelector);
        const phoneNo = get(localPartyLocalPhoneNumberSelector);
        return areaCode || phoneNo
            ? validateSchema(partyAreaCodeSchema, get(localPartyAreaCodeSelector))
            : alwaysValid(null);
    },
});
export const localPartyLocalPhoneNumberValidationSelector = selector({
    key: 'validation/local/partyLocalPhoneNumber',
    get: ({ get }) => {
        const areaCode = get(localPartyAreaCodeSelector);
        const phoneNo = get(localPartyLocalPhoneNumberSelector);
        return areaCode || phoneNo
            ? validateSchema(partyLocalPhoneNumberSchema, get(localPartyLocalPhoneNumberSelector))
            : alwaysValid(null);
    },
});
export const localPartyCountryCallingCodeRequiredValidationSelector = selector({
    key: 'validation/local/required/partyCountryCallingCode',
    get: ({ get }) => {
        const countryCode = get(localPartyCountryCallingCodeSelector);
        return validateSchema(partyCountryCallingCodeSchema, countryCode);
    },
});
export const localPartyAreaCodeRequiredValidationSelector = selector({
    key: 'validation/local/required/partyAreaCode',
    get: ({ get }) => {
        const areaCode = get(localPartyAreaCodeSelector);
        return validateSchema(partyAreaCodeSchema, areaCode);
    },
});
export const localPartyLocalPhoneNumberRequiredValidationSelector = selector({
    key: 'validation/local/required/partyLocalPhoneNumber',
    get: ({ get }) => {
        const phoneNo = get(localPartyLocalPhoneNumberSelector);
        return validateSchema(partyLocalPhoneNumberSchema, phoneNo);
    },
});
export const createPartyAddressFieldsValidationSelectorFamily = selectorFamily({
    key: 'validation/local/partyCommunicationForm/address',
    get: ({ communicationRoleGeo, optionalFields }) => ({ get }) => allValid({
        partyCountry: get(optionalFields?.country
            ? localPartyCountryNonRequiredValidationSelectorFamily(communicationRoleGeo)
            : localPartyCountryValidationSelectorFamily(communicationRoleGeo)),
        partyPostalCode: get(localPartyPostalCodeValidationSelectorFamily(communicationRoleGeo)),
        partyCity: get(localPartyCityValidationSelectorFamily(communicationRoleGeo)),
        partyStreet: get(optionalFields?.street
            ? localPartyStreetNonRequiredValidationSelectorFamily(communicationRoleGeo)
            : localPartyStreetValidationSelectorFamily(communicationRoleGeo)),
        partyHouseNumberFrom: get(optionalFields?.houseNumber
            ? localPartyHouseNumberFromNonRequiredValidationSelectorFamily(communicationRoleGeo)
            : localPartyHouseNumberFromValidationSelectorFamily(communicationRoleGeo)),
        partyHouseNumberTo: get(localPartyHouseNumberToValidationSelectorFamily(communicationRoleGeo)),
    }),
});
export const createPartyCommunicationFormValidationSelectorFamily = selectorFamily({
    key: 'validation/local/partyCommunicationForm',
    get: ({ communicationRoleGeo, optionalGeoAddressFields, isEmailRequired = true, isECommunicationRequired = true, isPhoneRequired = true, }) => ({ get }) => {
        const addressValidation = get(createPartyAddressFieldsValidationSelectorFamily({
            communicationRoleGeo,
            optionalFields: optionalGeoAddressFields,
        }));
        const otherCommunicationChannelsValidation = allValid({
            partyEmail: get(isEmailRequired
                ? localPartyEmailValidationSelector
                : localPartyEmailNonRequiredValidationSelector),
            partyECommunication: isECommunicationRequired
                ? get(localECommunicationValidationSelector)
                : alwaysValid(null),
            partyCountryCallingCode: isPhoneRequired
                ? get(localPartyCountryCallingCodeRequiredValidationSelector)
                : get(localPartyCountryCallingCodeValidationSelector),
            partyAreaCode: isPhoneRequired
                ? get(localPartyAreaCodeRequiredValidationSelector)
                : get(localPartyAreaCodeValidationSelector),
            partyCreatePhoneNo: isPhoneRequired
                ? get(localPartyLocalPhoneNumberRequiredValidationSelector)
                : get(localPartyLocalPhoneNumberValidationSelector),
        });
        return {
            valid: addressValidation.valid &&
                otherCommunicationChannelsValidation.valid,
            empty: addressValidation.empty &&
                otherCommunicationChannelsValidation.empty,
            errors: {
                ...addressValidation.errors,
                ...otherCommunicationChannelsValidation.errors,
            },
        };
    },
});
export const localPartyHouseholdMoveTypeValidationSelector = selector({
    key: 'validation/local/partyHouseholdMoveType',
    get: ({ get }) => validateSchema(partyLocalHouseHoldMoveTypeSchema, get(localPartyHouseholdMoveTypeAtom)),
});
export const localPartyHouseholdMoveTypeFormValidationSelector = selector({
    key: 'validation/local/partyHouseholdMoveTypeForm',
    get: ({ get }) => allValid({
        partyHouseholdMoveType: get(localPartyHouseholdMoveTypeValidationSelector),
    }),
});
export const localPartyHouseholdMergeSelectionValidationSelector = selector({
    key: 'validation/local/partyHouseholdMergeSelection',
    get: ({ get }) => validateSchema(partyLocalHouseHoldMergeSelectionSchema, get(localPartyHouseholdMergeSelectionAtom)),
});
export const localPartyHouseholdMergeSelectionFormValidationSelector = selector({
    key: 'validation/local/partyHouseholdMergeSelectionForm',
    get: ({ get }) => allValid({
        partyHouseholdMergeSelection: get(localPartyHouseholdMergeSelectionValidationSelector),
    }),
});
